var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21_",
    d: "M2.18424 22.7246L3.45922 24.936C3.72413 25.4015 4.10549 25.7676 4.55346 26.0342L9.12685 22.7916L9.13517 18.1363L4.57124 16.0801L4.63752e-06 18.1199C-0.000901613 18.6348 0.131014 19.1499 0.395979 19.6155L2.18424 22.7246Z",
    fill: "#0066DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20_",
    d: "M14.5166 8.84391L14.7552 2.77974L9.96314 0.929688C9.51421 1.19465 9.13154 1.55936 8.86494 2.02393L0.401299 16.6251C0.134748 17.0897 0.00090625 17.6043 0 18.1192L9.13517 18.1355L14.5166 8.84391Z",
    fill: "#00AD3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19_",
    d: "M14.5166 8.84438L18.9065 6.48281L19.0983 0.946471C18.6503 0.679921 18.1356 0.546136 17.6042 0.545173L11.4587 0.534184C10.9272 0.533221 10.4121 0.68179 9.96313 0.930159L14.5166 8.84438Z",
    fill: "#00831E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18_",
    d: "M19.8648 18.1549L9.13513 18.1357L4.55347 26.0336C5.00144 26.3001 5.51613 26.4339 6.04759 26.4349L22.9227 26.465C23.4542 26.466 23.9694 26.3174 24.4183 26.0691L24.4361 20.7641L19.8648 18.1549Z",
    fill: "#0084FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17_",
    d: "M24.4184 26.0697C24.8673 25.8047 25.25 25.44 25.5165 24.9755L26.0497 24.0629L28.5988 19.666C28.8654 19.2014 28.9992 18.6868 29.0001 18.1718L23.72 15.3936L19.8816 18.1556L24.4184 26.0697Z",
    fill: "#FF4131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16_",
    d: "M24.3984 9.3602L20.1926 2.04449C19.9277 1.57891 19.5463 1.21284 19.0983 0.946289L14.5166 8.8442L19.8648 18.1551L28.9834 18.1714C28.9843 17.6565 28.8523 17.1414 28.5874 16.6758L24.3984 9.3602Z",
    fill: "#FFBA00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive);
export default __webpack_public_path__ + "static/media/drive.d2de46592b3f3b5d2ac15cda50f7db4d.svg";
export { ForwardRef as ReactComponent };